import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, ApiClientError } from '../api';
import { useAuthStore } from '../store';
import { ErrorBox, PageHeader } from '../components/Common';
import { getWebApp } from '../telegram';

export function ProfilePage() {
  const user = useAuthStore((s) => s.user);
  const refresh = useAuthStore((s) => s.refreshMe);
  const logout = useAuthStore((s) => s.logout);
  const queryClient = useQueryClient();

  const [first, setFirst] = useState(user?.first_name ?? '');
  const [last, setLast] = useState(user?.last_name ?? '');
  const [phone, setPhone] = useState(user?.phone ?? '');

  const save = useMutation({
    mutationFn: () =>
      api.users.update({
        first_name: first,
        last_name: last || null,
        phone: phone || null,
      }),
    onSuccess: async () => {
      await refresh();
      void queryClient.invalidateQueries();
    },
  });

  const remove = useMutation({
    mutationFn: () => api.users.delete(),
    onSuccess: () => {
      logout();
      window.location.assign('/app');
    },
  });

  return (
    <div className="space-y-4">
      <PageHeader
        title="Профиль"
        subtitle={user?.username ? `@${user.username}` : undefined}
      />

      <div className="card space-y-3">
        <div>
          <label className="label">Имя</label>
          <input className="input" value={first} onChange={(e) => setFirst(e.target.value)} />
        </div>
        <div>
          <label className="label">Фамилия</label>
          <input className="input" value={last} onChange={(e) => setLast(e.target.value)} />
        </div>
        <div>
          <label className="label">Телефон</label>
          <input
            className="input"
            placeholder="+7..."
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            inputMode="tel"
          />
        </div>
        {save.error && (
          <ErrorBox
            message={
              save.error instanceof ApiClientError
                ? save.error.message
                : (save.error as Error).message
            }
          />
        )}
        <button className="btn-primary w-full" disabled={save.isPending} onClick={() => save.mutate()}>
          {save.isPending ? 'Сохраняем...' : save.isSuccess ? 'Сохранено ✓' : 'Сохранить'}
        </button>
      </div>

      <div className="card space-y-2">
        <p className="text-sm">Роль: <b>{user?.role}</b></p>
        <p className="text-xs text-tg-hint">
          Telegram ID: {user?.telegram_id}
        </p>
      </div>

      <button
        className="btn-secondary w-full text-red-400"
        disabled={remove.isPending}
        onClick={() => {
          const wa = getWebApp();
          const proceed = () => remove.mutate();
          const msg = 'Удалить аккаунт безвозвратно?';
          if (wa) wa.showConfirm(msg, (ok) => ok && proceed());
          else if (window.confirm(msg)) proceed();
        }}
      >
        Удалить аккаунт
      </button>
    </div>
  );
}
